module.exports = __webpack_public_path__ + "static/media/logo.7f279d55.svg";